export function getEmails(contact_method_associations) {
  return contact_method_associations.map(cma => cma.email).filter(Boolean)
}
